export const TABS = {
  ALL: 'ALL',
  ACTUAL: 'ACTUAL',
};
